// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.SAMPLE_SET_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.sampleSets.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
